import { addToCart } from "../redux/actions/CartActions";
import { setFormalityRequest } from "../redux/actions/FormalityActions";
import { getPaymentQuote } from "../redux/actions/PaymentActions";
import { requestTitle } from "./requestDisplay";

// An unpaid request is offered for payment during this number of days;
// older ones are most likely abandoned
export const UNPAID_VISIBLE_DAYS = 30;

const DAY = 24 * 60 * 60 * 1000;

export const isUnpaid = (request) => request?.status === "initiated";

// Unpaid requests too old to be shown to the client
export const isStale = (request) =>
  isUnpaid(request) &&
  Date.now() - new Date(request.createdAt).getTime() >
    UNPAID_VISIBLE_DAYS * DAY;

// Opens the payment page for a request left unpaid. The amount comes from
// the server, at today's prices. Resolves with an error message, or null.
export const resumePayment = ({ dispatch, navigate, token, request }) =>
  new Promise((resolve) => {
    dispatch(
      getPaymentQuote(token, request.reference, async (response) => {
        if (!response.success) {
          resolve(response.message);
          return;
        }

        if (!response.data.payable) {
          resolve("Cette démarche a déjà été payée.");
          return;
        }

        await dispatch(setFormalityRequest(request));
        await dispatch(
          addToCart({
            from: "resume",
            title: requestTitle(request),
            price: response.data.amount,
          }),
        );

        resolve(null);
        navigate("/formality-payment");
      }),
    );
  });
